// extracted by mini-css-extract-plugin
export default {"modal_update_rss_url":"modal-update-rss-url_modal_update_rss_url__F+Ij5"};